import { createFileRoute, redirect } from "@tanstack/react-router";

import { UserStep } from "~/pages/onboard/steps/user-step";

/**
 * Personal onboarding step #1: profile + role. Strict gate -- only renders
 * if the user is currently at this step.
 */
export const Route = createFileRoute("/onboard/user")({
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "user") {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: UserStep,
});
